export const frontmatter = {
    "draft": false,
    "title": "Contacts",
    "sidebar_group": "reference",
    "sidebar_label": "Contacts",
    "sidebar_order": 6
}

export const toc = []